import { render, staticRenderFns } from "./DialogoDarBaixa.vue?vue&type=template&id=9f6b60ee&scoped=true&"
import script from "./DialogoDarBaixa.vue?vue&type=script&lang=js&"
export * from "./DialogoDarBaixa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f6b60ee",
  null
  
)

export default component.exports